import React, { Component } from 'react'
import { connect } from 'react-redux'

import { fetchAlbums } from '../../redux/albums'
import { fetchPlaylists } from '../../redux/playlists'
import { addImagesToAlbum, saveAlbum } from '../../redux/album'
import { emptyStructure } from '../../redux/query'

import classNames from './common.css'
import listClassNames from './AddImagesToAlbum.css'
import Modal from '../modals/Modal'
import LoadingSpinner from '../LoadingSpinner'
import ErrorMessage from '../ErrorMessage'
import Icon from '../Icon'
import AlbumPicker from '../playlist/AlbumPicker'
import { mapStateToLists } from '../../utils/lists'
import { createImageGetter } from '../../utils/images'

class AddImagesToAlbum extends Component {
  state = {
    selected: [],
    showNewAlbumInput: false,
    newAlbum: '',
    submitting: false,
    success: false,
    error: null
  }
  componentDidMount () {
    const { albums, fetchAlbums, lists, fetchPlaylists } = this.props
    if (!albums) {
      fetchAlbums()
    }
    if (!lists) {
      fetchPlaylists()
    }
  }
  onSubmit = () => {
    const { entities, images, addImagesToAlbum, saveAlbum } = this.props
    const { selected, newAlbum } = this.state
    this.setState({
      submitting: true
    })
    const promises = selected.map(id => {
      const album = entities.albums[id]
      return addImagesToAlbum(album, images)
    })
    if (newAlbum) {
      const structure = {
        ...emptyStructure,
        include: images
      }
      promises.push(saveAlbum({
        name: newAlbum,
        cover: images[0],
        presentation_type: null,
        presentation_speed: null,
        presentation_transition: null,
        presentation_sort: null
      }, structure, undefined, false))
    }
    Promise.all(promises).then(this.props.onCancel).catch(error => {
      this.setState({
        error,
        submitting: false
      })
    })
  }
  onSelectAlbum = id => {
    this.setState({
      selected: this.state.selected.concat(id),
      success: false
    }, this.onSubmit) // Submit on select
  }
  onRemoveAlbum = id => {
    this.setState({
      selected: this.state.selected.filter(s => s !== id)
    })
  }
  renderItem = id => {
    const { entities, getImageSource, isOwner, getOwner } = this.props
    const album = entities.albums[id]
    const info = isOwner(album) ? null : 'Shared by ' + getOwner(album)
    return (
      <li key={album.id} className={listClassNames.album}>
        <div
          className={listClassNames.thumb}
          style={{ backgroundImage: `url(${getImageSource(album.cover)})` }}
        />
        <div className={listClassNames.name}>
          {album.name}
          {info &&
            <div className={listClassNames.info}>
              {info}
            </div>
          }
        </div>
        <button onClick={() => this.onRemoveAlbum(id)} className={listClassNames.button}>
          <Icon icon='close' />
        </button>
      </li>
    )
  }
  renderContent () {
    const { albums, lists, fetching, error, fetchAlbums } = this.props

    if (fetching || !albums || !lists) {
      return <LoadingSpinner />
    }

    if (error) {
      <ErrorMessage
        message='There was an error fetching albums'
        onRetry={fetchAlbums}
      />
    }

    const { isOwner, onCancel } = this.props
    const { selected, newAlbum, success, submitting } = this.state

    return (
      <div>
        <div className={classNames.label}>
          Select an album to add images
        </div>
        {selected.length !== 0 &&
          <ul className={listClassNames.list}>
            {selected.map(this.renderItem)}
          </ul>
        }
        {!this.state.showNewAlbumInput &&
          <AlbumPicker
            albums={albums}
            lists={lists}
            isOwner={isOwner}
            onChange={this.onSelectAlbum}
            exclude={selected}
            resetOnChange
            collapseOnSelect
            placeholder='Choose from your albums or create new'
            getImageSource={this.props.getImageSource}
            onCreateNewAlbum={() => this.setState({ showNewAlbumInput: true })}
          />
        }
        {this.state.showNewAlbumInput &&
          <input
            type='text'
            value={newAlbum}
            onChange={e => this.setState({ newAlbum: e.target.value })}
            placeholder='Enter a new album name'
          />
        }
        {success &&
          <p className={classNames.note}>
            Images successfully added to albums
          </p>
        }
        {error &&
          <p className={classNames.note}>
            There was an error adding images to albums
          </p>
        }
        <div className={classNames.buttons}>
          <button onClick={onCancel} className={success ? classNames.button : classNames.backButton}>
            {success ? 'Done' : 'Cancel'}
          </button>
          {!success &&
            <button onClick={this.onSubmit} className={classNames.button} disabled={submitting}>
              {submitting ? 'Adding Images…' : 'Add Images'}
            </button>
          }
        </div>
      </div>
    )
  }
  render () {
    return (
      <Modal title='Add images to album' onClose={this.props.onCancel}>
        <div className={classNames.page}>
          {this.renderContent()}
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = ({ albums, playlists, entities, auth }) => ({
  lists: mapStateToLists(playlists, entities),
  albums: albums.all.data && albums.all.data
    .map(id => entities.albums[id])
    .filter(album => {
      return (
        album.user_id === auth.user.id &&
        !album.image_share &&
        !album.favourite
      )
    }),
  isOwner: album => album.user_id === auth.user.id,
  getOwner: album => entities.users[album.user_id],
  getImageSource: createImageGetter(auth),
  fetching: albums.all.fetching,
  error: albums.all.error,
  entities
})

const mapDispatchToProps = {
  fetchAlbums,
  fetchPlaylists,
  addImagesToAlbum,
  saveAlbum
}

export default connect(mapStateToProps, mapDispatchToProps)(AddImagesToAlbum)



// WEBPACK FOOTER //
// ./src/components/album/AddImagesToAlbum.js